import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { TerminalContractsTable } from "./TerminalContractsTable";

export const TerminalContractsTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <TerminalContractsTable key={field.name} readOnly={readOnly} />
        </Form.Item>
    );
};
